module.exports.config = {
  declarative: true,
  "render-module": {
    name: "PieceTableRenderModule",
    path: "front/piece-table-render.module"
  },
  "cms-module": {
    name: "PieceTableCmsModule",
    path: "front/piece-table-cms.module"
  },
  definition: {
    type: "table",
    name: "PieceTableDefinition",
    group: "Components",
    availablePlatforms: ["web", "apps"],
    description: "Tabla",
    isOnlyAvailableWithCollections: true,
    fields: [
      { name: "linkedCollection", label: "Vincular colección", type: "linkedCollection", mandatory: true },
      { name: "tableFields", label: "Campos de la tabla", type: "pieceTable" },
      {
        name: "tableStyles",
        label: "Estilos de la tabla",
        type: "groupCollapsable",
        fields: [
          { name: "tableColumns", label: "Columnas a mostrar", type: "tableColumns" },
          { name: "firstRowSticky", label: "Primera fila fija", type: "boolean" },
          { name: "firstColumnSticky", label: "Primera columna fija", type: "boolean" }
        ]
      },
      {
        name: "theme",
        label: "Aspecto de la tabla",
        type: "options",
        section: "styles",
        defaultValue: "default",
        values: [
          { label: "Por defecto", value: "default" },
          {
            label: "Clases personalizadas",
            value: "customClasses",
            shouldDisplayWhenSelected: "customClassesList",
            jsonPath: "styles.customClassesList"
          }
        ]
      }
    ]
  }
};
